import Image from 'next/image';
import { motion } from 'framer-motion';
import { styled } from 'styled-components';
export const ItemList = styled(motion.li).withConfig({
  displayName: "MenuTitleMobilestyle__ItemList",
  componentId: "sc-ot88cd-0"
})(["", " a{", " &:hover{", "}}"], {
  "position": "relative",
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "alignItems": "center",
  "gap": "0.25rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem"
}, {
  "position": "relative",
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "gap": "0.25rem"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(23 23 23 / var(--tw-text-opacity, 1))"
});
export const WrapperItemList = styled.div.withConfig({
  displayName: "MenuTitleMobilestyle__WrapperItemList",
  componentId: "sc-ot88cd-1"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.25rem"
});
export const MenuImgWrapper = styled.div.withConfig({
  displayName: "MenuTitleMobilestyle__MenuImgWrapper",
  componentId: "sc-ot88cd-2"
})(["", ""], {
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 231 234 / var(--tw-bg-opacity, 1))",
  "objectFit": "contain",
  "padding": "0.375rem"
});
export const MenuText = styled.div.withConfig({
  displayName: "MenuTitleMobilestyle__MenuText",
  componentId: "sc-ot88cd-3"
})(["", " &.active{", "}"], {
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem",
  "fontSize": "28px",
  "fontWeight": "500",
  "lineHeight": "30px"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(206 14 45 / var(--tw-text-opacity, 1))"
});
export const MenuArrowIcon = styled(Image).withConfig({
  displayName: "MenuTitleMobilestyle__MenuArrowIcon",
  componentId: "sc-ot88cd-4"
})(["", ""], {
  "position": "absolute",
  "right": "0.5rem",
  "zIndex": "50",
  "width": "1.25rem"
});